import lodash from 'lodash'
import React, { ReactElement, useEffect, useMemo } from 'react'
import styled from 'styled-components'

import {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import { formatDecimal } from '../../../../../../../1stlog-ui/src/components/Field/format'
import useFieldState from '../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import InlineEditorInvalid from '../../../../../../../1stlog-ui/src/components/InlineEditor/InlineEditorInvalid'
import { useProductSettings } from '../../../../Products'

const Wrapper = styled.div``

const validate = (value: string | undefined): string | undefined => value

type TGirthProps = {
  readonly?: boolean
}

const Girth = (props: TGirthProps): ReactElement => {
  const { readonly } = props

  const { maxGirth, isMeasurementsHidden } = useProductSettings()

  const height = useField('height')
  const width = useField('width')
  const length = useField('length')

  const value = useMemo(() => {
    const obj = { height, width, length }
    const mapped = lodash.keys(obj).map((key) => ({
      value: Number(obj[key]),
      key,
    }))
    const sides = lodash
      .orderBy(mapped, ['value'], ['desc'])
      .map((item) => item.value)
    return sides[0] + sides[1] * 2 + sides[2] * 2
  }, [height, width, length])

  const {
    input: { value: isGirthInvalid, onChange: setIsGirthInvalid },
  } = useField('validation.isGirthInvalid', {
    raw: true,
    validate,
    subscribeAll: true,
  })

  useEffect(() => {
    const isInvalid = maxGirth && maxGirth < value
    setIsGirthInvalid(isInvalid ? `Max. ${maxGirth} cm` : undefined)
  }, [value, maxGirth])

  const [, setGirth] = useFieldState<number>('girth')
  useEffect(() => {
    setTimeout(() => {
      setGirth(value)
    }, 0)
  }, [value])

  if (isMeasurementsHidden) {
    return <></>
  }

  return (
    <Wrapper className="text-center">
      <Label>{i18n.t('girth2', 'Gurtmaß')}</Label>
      <h5 className={readonly ? 'mt-1' : 'mt-2'}>
        {isNaN(value) ? (
          <InlineEditorInvalid />
        ) : (
          <span>{formatDecimal(value, 0)} cm</span>
        )}
      </h5>
      {isGirthInvalid && (
        <div className="text-danger mb-1 text-left">{isGirthInvalid}</div>
      )}
    </Wrapper>
  )
}

export default Girth
